import React from 'react'

function IdentityUserIcon () {
  return (
    <div>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='52'
        height='52'
        viewBox='0 0 52 52'
      >
        <g
          id='Group_12545'
          data-name='Group 12545'
          transform='translate(-40 -816)'
        >
          <rect
            id='Rectangle_7223'
            data-name='Rectangle 7223'
            width='52'
            height='52'
            rx='16'
            transform='translate(40 816)'
            fill='#e85c87'
          />
          <path
            id='user-1'
            d='M185.093,74.236v-.906a3.983,3.983,0,0,0-2.06-3.5l-3.416-2.137a1.114,1.114,0,0,1-.586-.953V65.356a7.679,7.679,0,0,0,1.865-3.179,1.8,1.8,0,0,0,.663-1.4V59.034a1.764,1.764,0,0,0-.5-1.178V55.517c0-.047-.308-4.517-5.553-4.517s-5.553,4.476-5.559,4.547v2.315a1.764,1.764,0,0,0-.5,1.178v1.746a1.8,1.8,0,0,0,.663,1.4,7.679,7.679,0,0,0,1.865,3.179v1.385a1.118,1.118,0,0,1-.616.965L167.99,69.82a4,4,0,0,0-2.09,3.517v.906'
            transform='translate(-109.9 779.313)'
            fill='none'
            stroke='#fff'
            stroke-linecap='round'
            stroke-linejoin='round'
            stroke-miterlimit='10'
            stroke-width='2'
          />
        </g>
      </svg>
    </div>
  )
}

export default IdentityUserIcon
